import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpecificationFile} from '../../../models/specificationViewer';

type SpecFilesProps = {
    files: SpecificationFile[];
}

const SpecFiles: React.FC<SpecFilesProps> = ({files}) => {
    const {t} = useTranslation();

    if (files.length === 0) {
        return <div className="procedure-text">{t('specificationViewer.noFiles')}</div>;
    }

    return (
        <div className="spec-files">
            {files.map(file => (
                <div className="file-item" key={file.id}>
                    <div className="file-name">{file.originalName}</div>
                    {file.isImage ? (
                        <img
                            src={process.env.REACT_APP_API_ENDPOINT + 'file/uploads/' + file.path}
                            alt={file.originalName}
                            loading="lazy"
                        />
                    ) : (
                        <a
                            href={process.env.REACT_APP_API_ENDPOINT + 'file/uploads/' + file.path}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {file.originalName}
                        </a>
                    )}
                </div>
            ))}
        </div>
    );
};

export default SpecFiles;
